export default class VideoLink {

    constructor(public id: number, public name: string, public description: string, public link: string, public html: string) {
    }
    
}
